export const scramble = (input: Array<number>) =>
  input.sort(() => Math.random() - 0.5)
export const createAscendingArray = (start: number, end: number) => {
  return Array(end - start + 1)
    .fill(0)
    .map((_, idx) => start + idx)
}
